import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './manageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import { icons } from '../../../../assets/icons/icons'
import { debouncedApiCall } from '../../../../utils/app.utils'
import TableCustom from '../../../../components/table/tableCustom'
import { library_history_status_data } from '../../enum/elibrary_enum'

type Props = {}

const ManageBorrow: React.FC<Props> = (props: Props) => {
    const {
        path_name,
        set_search,
        handleChangeDateRange,
        end_date,
        start_date,
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        totalItems,
        data,
        library_history_status,
        set_library_history_status,
        set_step,
        step,
        handleClearFilter,
        key_search
    } = useManageState();

    return (
        <ContainerLayout
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library",
                            name: "จัดการข้อมูล E-Library",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "จัดการข้อมูลการยืมหนังสือ",
                            name: "จัดการข้อมูลการยืมหนังสือ",
                            pathName: path_name
                        },
                    ]}
                />
            }
            title='จัดการข้อมูลการยืมหนังสือ'
            between_title={
                <span>
                    <Button onClick={() => {
                        set_step(0);
                        handleClearFilter();
                    }} variant={step === 0 ? 'contained' : 'outlined'}
                        sx={{
                            borderRadius: "8px 0px 0px 8px",
                            backgroundColor: step === 0 ? "#9E640E" : ""
                        }}>
                        สถานะทั่วไป
                    </Button>
                    <Button onClick={() => {
                        set_step(1);
                        handleClearFilter();
                    }} variant={step === 0 ? 'outlined' : 'contained'}
                        sx={{
                            borderRadius: "0px 8px 8px 0px",
                            backgroundColor: step === 0 ? "" : "#9E640E"
                        }}>
                        สถานะจอง
                    </Button>
                </span>
            }
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    key: key_search,
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                    startAdornment: <Box mr={1}> <icons.SearchNormal /></Box>,
                                    placeholder: "ค้นหาชื่อ"
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: "ช่วงวันที่",
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 3,
                                type: "AUTO-COMPLETE",
                                hidden: step === 1,
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label || "",
                                    labelId: "library_history_status",
                                    placeholder: "ทุกสถานะ",
                                    onChange: (_, op) => set_library_history_status(op ?? null),
                                    options: library_history_status_data,
                                    value: library_history_status
                                }
                            },
                        ]}
                    />


                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </Box>
            }
        />
    )
}

export default ManageBorrow